<div mat-dialog-content class="confirm-message">
    <h1>Confirm!</h1>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions class="confirm-actions">
    <div class="form-row">
        <div class="col-md-6 col-6" >
            <button mat-button [mat-dialog-close]="true" class="btn btn-primary btn-md-circle btn-block" cdkFocusInitial>Yes</button>
        </div>
        <div class="col-md-6 col-6" >
            <button mat-button (click)="onNoClick()" class="btn btn-outline-primary w-100" >No</button>
        </div>
    </div>
</div>
<!-- <div> 
    <div class="content-container">
        <span class="content-span full-width">{{data.message}}</span>
    </div>
    <div>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
        <button mat-button [mat-dialog-close]="false" cdkFocusInitial>No</button>
    </div>
</div> -->
